export class CommentsData {
  totalCount!: number;
  canAddComment!: boolean;
  data!: ComplaintComment[];
}

export class ComplaintComment {
  id!: number;
  comment!: string;
  sendTo!: any[];
  createdDate!: string;
  createdBy!: string;
  logo!: string;
  canEdit!: boolean;
  canDelete!: boolean;
  canAddReply!: boolean;
  isCreator!: boolean;
  replies!: ComplaintComment[];
  isReply!:boolean;
  commentId!:number;
}


export class CommentFormModel {
  commentId!: number;
  ticketId!: number;
  comment!: string;
  parentCommentId!: number;
  sendTo!: string[];
}
